import classNames from 'classnames';
import { connect, getIn } from 'formik';
import { castArray } from 'lodash';
import PropTypes from 'prop-types';

const hasAnyError = ({ name, formik }) =>
  name.some(
    (_name) =>
      getIn(formik.errors, _name) &&
      (getIn(formik.touched, _name) || formik.submitCount > 0),
  );

const Wrapper = ({
  children,
  className,
  formik,
  name,
  required = false,
  simpleFormGemClass,
  tooltip,
  withoutCSS = false,
  withoutError = false,
}) => {
  name = castArray(name);
  const ukLabelClass = '';

  return (
    <div
      className={classNames(className, {
        required,
        field_with_errors: !withoutError && hasAnyError({ name, formik }),
        'push-half--bottom': !withoutCSS,
        [ukLabelClass]: ukLabelClass && !withoutCSS,
        [simpleFormGemClass]: simpleFormGemClass && !withoutCSS,
      })}
      data-testid="formik-wrapper"
      title={tooltip || undefined}
    >
      {children}
    </div>
  );
};

Wrapper.propTypes = {
  children: PropTypes.node.isRequired,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  className: PropTypes.string,
  required: PropTypes.bool,
  simpleFormGemClass: PropTypes.string,
  tooltip: PropTypes.string,
  withoutCSS: PropTypes.bool,
  withoutError: PropTypes.bool,
};

export default connect(Wrapper);
